// import {Hint} from 'components/Hint';
import {Typography} from 'components/Typography';
import {DetailedCharacteristicsTasteItem} from 'modules/product-card/components/DetailedCharacteristicsTasteItem';
import {IResultProductTasteCharacteristic} from 'modules/product-card/helpers/characteristics/taste';
import {FC} from 'react';
import style from './style.module.scss';

interface IProps {
    list: IResultProductTasteCharacteristic[];
}

/* TODO: После доработки api текст нужно брать с api, пока решили сделать рыбу */
// const TEST_PLACEHOLDER = 'После доработки api текст нужно брать с api, пока решили сделать рыбу';

export const DetailedCharacteristicsTasteList: FC<IProps> = ({list}) => {
    return (
        <div className={style.main}>
            <div className={style.title}>
                <Typography variant={'title-18-m'}>Вкус</Typography>
                {/* <Hint position="top-left" isFixedWidth isWhite text={TEST_PLACEHOLDER} />*/}
            </div>
            <div className={style.content}>
                {list.map(({title, value}) => {
                    return <DetailedCharacteristicsTasteItem key={title} title={title} value={value} />;
                })}
            </div>
        </div>
    );
};
